import React from 'react';
import { useParams } from 'react-router-dom';
import { UnitComparison } from '../components/UnitComparison';
import { UnitCategory } from '../types/units';
import { SEO } from '../components/SEO';

export default function UnitComparisonPage() {
  const { category = 'length' } = useParams<{ category: string }>();

  return (
    <div className="container mx-auto px-4 py-8">
      <SEO 
        title={`Compare ${category.charAt(0).toUpperCase() + category.slice(1)} Units`}
        description={`Compare different ${category} units side by side with visual representations and detailed explanations.`}
      />
      <UnitComparison category={category as UnitCategory} />
    </div>
  );
} 